import {
  postAsientosContablesImportSage,
  postLineasImpuestoImportSage,
} from "api/AsientoContable.service"
import { ContactoPublishImportarContactosSageCommand } from "api/Commands/ContactoPublishImportarContactosSageCommand"
import { LineaImportarAsientosContablesSageCommandProps } from "api/Commands/LineaImportarAsientosContablesSageCommand"
import { LineaImpuestoImportarLibroIvaSageCommandProps } from "api/Commands/LineaImpuestoImportarLibroIvaSageCommand"
import { postContactosImportSage } from "api/Contacto.service"
import { TIPO_ASIENTO } from "api/Types/TipoAsiento"
import { TIPO_FACTURA } from "api/Types/TipoFactura"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import moment from "moment"
import { INTEGRACIONES } from "routes/RoutePaths"
import * as Yup from "yup"

export const VARIABLE_ASIENTO_EMITIDO = "E"
export const VARIABLE_ASIENTO_REPERCUTIDO = "R"
export const VARIABLE_FACTURA_EMITIDA = "E"
export const VARIABLE_FACTURA_RECIBIDA = "R"

export const MODES_INTEGRACIONES = {
  ASIENTOS_CONTABLES: "asientosContables",
  CONTACTOS: "contactos",
  LIBRO_IVA: "libroIva",
}

export const TYPES_INTEGRACIONES = {
  SAGE: "sage",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const adapterIntegration = (values: $TSMigrationFixMe) => {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const { archive, options } = values?.[`${values.screen}`]

  if (!archive || !archive.items) {
    return { [`${values.screen}`]: [] }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const elementPost = archive?.items.map((item: $TSMigrationFixMe) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mappedItem: { [key: string]: $TSMigrationFixMe } = {}

    Object.keys(options).forEach((key: string) => {
      mappedItem[key] = item[options[key] ?? ""]
    })

    return mappedItem
  })

  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [`${values.screen}`]: elementPost.filter((item: $TSMigrationFixMe) => {
      return Object.values(item).some((value) => value !== null)
    }),
  }
}

const formatDate = (dateString: string, format: string): string => {
  const date = moment(dateString, "DD/MM/YYYY")
  return date.format(format)
}

export const extractProgressPercentage = (progressMessage: string) => {
  const progressRegex = /Progreso:\s*(\d+)%/
  const match = progressMessage.match(progressRegex)

  if (match) {
    const progressPercentageString = match[1]
    return Number(progressPercentageString)
  }
  return null
}

const adapterAsientosContablesPost = (
  asientos: {
    asiento: string | null
    codigoCuenta: string | null
    comentario: string | null
    cuenta: string | null
    debe: number
    documentoConta: string | null
    fechaAsiento: string
    haber: number
    tipoFactura: string | null
  }[]
): LineaImportarAsientosContablesSageCommandProps[] => {
  return asientos.map(
    (asiento: {
      asiento: string | null
      codigoCuenta: string | null
      comentario: string | null
      cuenta: string | null
      debe: number
      documentoConta: string | null
      fechaAsiento: string
      haber: number
      tipoFactura: string | null
    }) => {
      return {
        asiento: asiento.asiento ?? null,
        codigoCuenta: asiento.codigoCuenta ?? null,
        comentario: asiento.comentario ?? null,
        cuenta: asiento.cuenta ?? null,
        debe: asiento.debe,
        documentoConta: asiento.documentoConta ?? null,
        fechaAsiento: formatDate(asiento.fechaAsiento, "YYYY-MM-DD"),
        haber: asiento.haber,
        tipoAsiento:
          asiento.tipoFactura === VARIABLE_ASIENTO_EMITIDO
            ? TIPO_ASIENTO.FACTURA_EMITIDA
            : asiento.tipoFactura === VARIABLE_ASIENTO_REPERCUTIDO
            ? TIPO_ASIENTO.FACTURA_RECIBIDA
            : null,
      }
    }
  )
}

const adapterContactosPost = (
  contactos: {
    cifDni: string | null
    codigoCliente: string | null
    codigoProveedor: string | null
    codigoPostal: string | null
    domicilio: string | null
    email1: string | null
    email2: string | null
    municipio: string | null
    iban: string | null
    nombre: string | null
    siglanacion: string | null
    telefono: string | number | null
    telefono2: string | number | null
    telefono3: string | number | null
    tipoContacto: string | null
  }[]
): ContactoPublishImportarContactosSageCommand[] => {
  return contactos.map(
    (contacto: {
      cifDni: string | null
      codigoCliente: string | null
      codigoProveedor: string | null
      codigoPostal: string | null
      domicilio: string | null
      email1: string | null
      email2: string | null
      iban: string | null
      municipio: string | null
      nombre: string | null
      siglanacion: string | null
      telefono: string | number | null
      telefono2: string | number | null
      telefono3: string | number | null
      tipoContacto: string | null
    }) => {
      const telefonosArray = [
        contacto.telefono,
        contacto.telefono2,
        contacto.telefono3,
      ].filter((telefono): telefono is string => Boolean(telefono))

      const emailArray = [contacto.email1, contacto.email2].filter(
        (email): email is string => Boolean(email)
      )
      return {
        codigoPais: contacto.siglanacion ?? null,
        codigoPostal: contacto.codigoPostal
          ? String(contacto.codigoPostal)
          : null,
        direccion: contacto.domicilio ?? null,
        emails: emailArray.length > 0 ? emailArray : null,
        nif: contacto.cifDni ?? null,
        poblacion: contacto.municipio ?? null,
        iban: contacto.iban ?? null,
        nombre: contacto.nombre ?? null,
        numeroCuentaContableCliente: contacto.codigoCliente
          ? String(contacto.codigoCliente)
          : null,
        numeroCuentaContableProveedor: contacto.codigoProveedor
          ? String(contacto.codigoProveedor)
          : null,
        telefonos: telefonosArray.length > 0 ? telefonosArray : null,
      }
    }
  )
}

interface LineaImpuesto {
  fecha: string
  baseIva: number
  claveIva: string | null
  cuotaIva: number
  porcentajeIva: number
  noDeducible: number
  numeroFactura: string | null
  numeroProveedorFactura: string | null
  baseRetencion: number
  claveRetencion: string | null
  cuotaRetencion: number
  porcentajeRetencion: number
  serieFactura: string | null
  tipoFactura: string | null
  nifContacto: string | null
  razonSocial: string | null
}

const adapterLibroIvaPost = (
  lineasImpuesto: LineaImpuesto[]
): LineaImpuestoImportarLibroIvaSageCommandProps[] => {
  return lineasImpuesto.map((lineaImpuesto: LineaImpuesto) => {
    const isRetencionEmpty =
      !lineaImpuesto.baseRetencion &&
      !lineaImpuesto.claveRetencion &&
      !lineaImpuesto.cuotaRetencion &&
      !lineaImpuesto.porcentajeRetencion
    return {
      fecha: lineaImpuesto.fecha
        ? formatDate(lineaImpuesto.fecha, "YYYY-MM-DD")
        : null,
      iva: {
        base: lineaImpuesto.baseIva,
        clave: lineaImpuesto.claveIva,
        cuota: lineaImpuesto.cuotaIva,
        porcentaje: lineaImpuesto.porcentajeIva,
        noDeducible: lineaImpuesto.noDeducible ?? 0,
      },
      numeroFactura: lineaImpuesto.numeroFactura ?? null,
      numeroProveedorFactura: lineaImpuesto.numeroProveedorFactura ?? null,
      serieFactura: lineaImpuesto.serieFactura ?? null,
      nifContacto: lineaImpuesto.nifContacto ?? null,
      retencion: isRetencionEmpty
        ? null
        : {
            base: lineaImpuesto.baseRetencion,
            clave: lineaImpuesto.claveRetencion,
            cuota: lineaImpuesto.cuotaRetencion,
            porcentaje: lineaImpuesto.porcentajeRetencion,
            noDeducible: lineaImpuesto.noDeducible ?? 0,
          },
      tipoFactura:
        lineaImpuesto.tipoFactura === VARIABLE_FACTURA_EMITIDA
          ? TIPO_FACTURA.FACTURA_EMITIDA
          : lineaImpuesto.tipoFactura === VARIABLE_FACTURA_RECIBIDA
          ? TIPO_FACTURA.FACTURA_RECIBIDA
          : null,
      razonSocial: lineaImpuesto.razonSocial ?? null,
    }
  })
}

export const submitIntegration = async (
  values: $TSMigrationFixMe,
  setFieldValue: (
    field: string,
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => void,
  isOmitir: boolean,
  history: $TSMigrationFixMe,
  t: TFunction,
  setShowLoadingModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    setFieldValue("loadingSubmit", true)
    if (values.screen === MODES_INTEGRACIONES.ASIENTOS_CONTABLES) {
      if (!isOmitir) {
        const data = adapterIntegration(values)
        if (values.type === TYPES_INTEGRACIONES.SAGE) {
          const resp = await postAsientosContablesImportSage({
            lineas: adapterAsientosContablesPost(data.asientosContables),
            nombreFichero: values?.asientosContables?.nombreArchivo ?? null,
          })

          if (resp.status === STATUSCORRECT) {
            notification.success({
              body: `${t("notification.integrationUpdateLibroDiario")}`,
            })
            setFieldValue("asientosContables.status", true)

            values?.contactos?.status === false &&
              values?.contactos?.show === true &&
              setFieldValue("screen", MODES_INTEGRACIONES.CONTACTOS)

            values?.libroIva?.status === false &&
              values?.libroIva?.show === true &&
              setFieldValue("screen", MODES_INTEGRACIONES.LIBRO_IVA)

            values?.libroIva?.status === true &&
              values?.contactos?.status === true &&
              history.push(INTEGRACIONES)
          }
        }
      }
    }
    if (values.screen === MODES_INTEGRACIONES.CONTACTOS) {
      if (!isOmitir) {
        const data = adapterIntegration(values)
        if (values.type === TYPES_INTEGRACIONES.SAGE) {
          const resp = await postContactosImportSage({
            contactos: adapterContactosPost(data.contactos),
            nombreFichero: values?.contactos?.nombreArchivo ?? null,
          })

          if (resp.status === STATUSCORRECT) {
            notification.success({
              body: `${t("notification.integrationUpdateLibroDiario")}`,
            })
            setFieldValue("contactos.status", true)

            values?.asientosContables?.status === false &&
              values?.asientosContables?.show === true &&
              setFieldValue("screen", MODES_INTEGRACIONES.ASIENTOS_CONTABLES)

            values?.libroIva?.status === false &&
              values?.libroIva?.show === true &&
              setFieldValue("screen", MODES_INTEGRACIONES.LIBRO_IVA)

            values?.libroIva?.status === true &&
              values?.asientosContables?.status === true &&
              history.push(INTEGRACIONES)
          }
        }
      }
    }
    if (values.screen === MODES_INTEGRACIONES.LIBRO_IVA) {
      if (!isOmitir) {
        const data = adapterIntegration(values)
        if (values.type === TYPES_INTEGRACIONES.SAGE) {
          setShowLoadingModal(true)
          const resp = await postLineasImpuestoImportSage({
            lineasImpuesto: adapterLibroIvaPost(data.libroIva),
          })

          if (resp.status === STATUSCORRECT) {
            notification.success({
              body: `${t("notification.integrationUpdateLibroIva")}`,
            })
            setFieldValue("libroIva.status", true)

            values?.contactos?.status === false &&
              values?.contactos?.show === true &&
              setFieldValue("screen", MODES_INTEGRACIONES.CONTACTOS)

            values?.asientosContables?.status === false &&
              values?.asientosContables?.show === true &&
              setFieldValue("screen", MODES_INTEGRACIONES.ASIENTOS_CONTABLES)

            values?.asientosContables?.status === true &&
              values?.contactos?.status === true &&
              history.push(INTEGRACIONES)
          }
        }
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    setFieldValue("loadingSubmit", false)
  } finally {
    setShowLoadingModal(false)
  }
}

export const OPTIONS_DROP = (t: TFunction, screen: string) => {
  if (screen === MODES_INTEGRACIONES.ASIENTOS_CONTABLES)
    return [
      {
        id: "fechaAsiento",
        value: t("integracion.update.fechaAsiento"),
        aliases: ["fechaAsiento", "fecha asiento"],
      },
      {
        id: "codigoCuenta",
        value: t("integracion.update.codCuenta"),
        aliases: ["codigoCuenta", "Código cuenta"],
      },
      {
        id: "asiento",
        value: t("integracion.update.numAsiento"),
        aliases: ["asiento", "Número de asiento"],
      },
      {
        id: "comentario",
        value: t("integracion.update.coment"),
        aliases: ["comentario"],
      },
      {
        id: "debe",
        value: t("integracion.update.debe"),
        aliases: ["debe"],
      },
      {
        id: "haber",
        value: t("integracion.update.haber"),
        aliases: ["haber"],
      },
      {
        id: "documentoConta",
        value: t("integracion.update.docContable"),
        aliases: ["documentoConta", "documento"],
      },
      {
        id: "cuenta",
        value: t("integracion.update.cuenta"),
        aliases: ["Cuenta", "cuenta"],
      },
      {
        id: "tipoFactura",
        value: t("integracion.update.tipoFactura"),
        aliases: ["tipoFactura", "tipo factura"],
      },
    ]
  if (screen === MODES_INTEGRACIONES.CONTACTOS)
    return [
      {
        id: "telefono",
        value: t("integracion.update.tlf"),
        aliases: ["telefono"],
      },
      {
        id: "telefono2",
        value: t("integracion.update.tlf2"),
        aliases: ["telefono2"],
      },
      {
        id: "telefono3",
        value: t("integracion.update.tlf3"),
        aliases: ["telefono3"],
      },
      {
        id: "email1",
        value: t("integracion.update.mail"),
        aliases: ["email1", t("integracion.update.mail"), "email 1"],
      },
      {
        id: "email2",
        value: t("integracion.update.mail2"),
        aliases: ["email2"],
      },
      {
        id: "siglanacion",
        value: t("integracion.update.nationSig"),
        aliases: ["siglanacion"],
      },
      {
        id: "codigoPostal",
        value: t("integracion.update.postalSig"),
        aliases: ["codigoPostal"],
      },
      {
        id: "domicilio",
        value: t("integracion.update.direccion"),
        aliases: ["domicilio"],
      },
      {
        id: "iban",
        value: t("integracion.update.iban"),
        aliases: ["iban"],
      },
      {
        id: "cifDni",
        value: t("integracion.update.nif"),
        aliases: ["cifDni"],
      },
      {
        id: "municipio",
        value: t("integracion.update.poblacion"),
        aliases: ["municipio"],
      },
      {
        id: "nombre",
        value: t("integracion.update.nombre"),
        aliases: ["nombre"],
      },
      {
        id: "codigoCliente",
        value: t("integracion.update.cuentaContableCliente"),
        aliases: ["codigoCliente"],
      },
      {
        id: "codigoProveedor",
        value: t("integracion.update.cuentaContableProveedor"),
        aliases: ["codigoProveedor"],
      },
    ]
  if (screen === MODES_INTEGRACIONES.LIBRO_IVA)
    return [
      {
        id: "fecha",
        value: t("integracion.update.fechaFactura"),
        aliases: [t("integracion.update.fechaFactura"), "fechaFactura"],
      },
      {
        id: "baseIva",
        value: t("integracion.update.base"),
        aliases: [t("integracion.update.base"), "Base IVA", "baseIva"],
      },
      {
        id: "cuotaIva",
        value: t("integracion.update.quote"),
        aliases: [t("integracion.update.quote"), "Cuota IVA", "cuotaIva"],
      },
      {
        id: "porcentajeIva",
        value: t("integracion.update.tax"),
        aliases: [t("integracion.update.tax"), "%Iva", "% IVA", "% I.V.A."],
      },
      {
        id: "claveIva",
        value: t("integracion.update.field1"),
        aliases: [t("integracion.update.field1"), "campo1"],
      },
      {
        id: "noDeducible",
        value: t("integracion.update.nonDeductible"),
        aliases: [t("integracion.update.nonDeductible"), "NoDeducible"],
      },
      {
        id: "numeroFactura",
        value: t("integracion.update.billNumber"),
        aliases: [t("integracion.update.billNumber"), "factura"],
      },
      {
        id: "baseRetencion",
        value: t("integracion.update.retention"),
        aliases: [t("integracion.update.retention"), "baseRetencion"],
      },
      {
        id: "cuotaRetencion",
        value: t("integracion.update.quoteRetention"),
        aliases: [t("integracion.update.quoteRetention"), "ImporteRetencion"],
      },
      {
        id: "porcentajeRetencion",
        value: t("integracion.update.percentileRetention"),
        aliases: [t("integracion.update.percentileRetention"), "%Retencion"],
      },
      {
        id: "serieFactura",
        value: t("integracion.update.serieFactura"),
        aliases: [t("integracion.update.serieFactura"), "Serie"],
      },
      {
        id: "tipoFactura",
        value: t("integracion.update.tipoFactura"),
        aliases: [t("integracion.update.tipoFactura"), "tipoFactura"],
      },
      {
        id: "numeroProveedorFactura",
        value: t("integracion.update.providerBillNumber"),
        aliases: ["Su factura nº.", "SuFacturaNo"],
      },
      {
        id: "nifContacto",
        value: t("integracion.update.contactNif"),
        aliases: ["CIF europeo", "CifEuropeo"],
      },
      {
        id: "razonSocial",
        value: t("integracion.update.razonSocial"),
        aliases: ["Nombre Cli/Pro", "nombre"],
      },
    ]
  return []
}

export const SAGE_INFO = (options: {
  libroIva: boolean
  asientosContables: boolean
  contactos: boolean
  logo: string
  type: string
}) => ({
  asientosContables: {
    status: !options.asientosContables,
    show: options.asientosContables,
    archive: null,
    nombreArchivo: null,
    options: {
      fechaAsiento: null,
      codigoCuenta: null,
      comentario: null,
      debe: null,
      haber: null,
      documentoConta: null,
      cuenta: null,
      asiento: null,
      tipoFactura: null,
    },
  },
  contactos: {
    status: !options.contactos,
    show: options.contactos,
    archive: null,
    nombreArchivo: null,
    options: {
      telefono: null,
      telefono2: null,
      telefono3: null,
      iban: null,
      email1: null,
      email2: null,
      siglanacion: null,
      codigoPostal: null,
      domicilio: null,
      cifDni: null,
      codigoCliente: null,
      codigoProveedor: null,
      nombre: null,
      municipio: null,
      tipoContacto: null,
    },
  },
  libroIva: {
    status: !options.libroIva,
    show: options.libroIva,
    archive: null,
    options: {
      fecha: null,
      baseIva: null,
      cuotaIva: null,
      porcentajeIva: null,
      claveIva: null,
      noDeducible: 0,
      numeroFactura: null,
      baseRetencion: null,
      cuotaRetencion: null,
      porcentajeRetencion: null,
      claveRetencion: null,
      serieFactura: null,
      tipoFactura: null,
      numeroProveedorFactura: null,
      nifContacto: null,
      razonSocial: null,
    },
  },
})

export const validationSchemaIntegraciones = (t: TFunction) =>
  Yup.object().shape({
    contactos: Yup.object().when("screen", {
      is: MODES_INTEGRACIONES.CONTACTOS,
      then: Yup.object().shape({
        archive: Yup.object().nullable().required(),
        options: Yup.object()
          .shape({
            telefono: Yup.string()
              .nullable()
              .required(`${t("integracion.update.tlf")}`),
            email1: Yup.string()
              .nullable()
              .required(`${t("integracion.update.mail")}`),
            siglanacion: Yup.string()
              .nullable()
              .required(`${t("integracion.update.nationSig")}`),
            codigoPostal: Yup.string()
              .nullable()
              .required(`${t("integracion.update.postalSig")}`),
            domicilio: Yup.string()
              .nullable()
              .required(`${t("integracion.update.direccion")}`),
            cifDni: Yup.string()
              .nullable()
              .required(`${t("integracion.update.nif")}`),
            nombre: Yup.string()
              .nullable()
              .required(`${t("integracion.update.nombre")}`),
            codigoCliente: Yup.string()
              .nullable()
              .test(
                "codigoCliente OR codigoProveedor",
                // eslint-disable-next-line func-names
                function (value) {
                  const { codigoProveedor } = this.parent
                  if (!codigoProveedor && !value) {
                    return this.createError({
                      message: `${t(
                        "integracion.update.cuentaContableCliente"
                      )}`,
                    })
                  }
                  return true
                }
              ),
            codigoProveedor: Yup.string()
              .nullable()
              .test(
                "codigoProveedor OR codigoCliente",
                // eslint-disable-next-line func-names
                function (value) {
                  const { codigoCliente } = this.parent
                  if (!codigoCliente && !value) {
                    return this.createError({
                      message: `${t(
                        "integracion.update.cuentaContableProveedor"
                      )}`,
                    })
                  }
                  return true
                }
              ),
            municipio: Yup.string()
              .nullable()
              .required(`${t("integracion.update.poblacion")}`),
            iban: Yup.string()
              .nullable()
              .required(`${t("integracion.update.iban")}`),
          })
          .nullable(),
      }),
    }),
    asientosContables: Yup.object().when("screen", {
      is: MODES_INTEGRACIONES.ASIENTOS_CONTABLES,
      then: Yup.object().shape({
        archive: Yup.object().nullable().required(),
        options: Yup.object()
          .shape({
            fechaAsiento: Yup.string()
              .nullable()
              .required(`${t("integracion.update.fechaAsiento")}`),
            codigoCuenta: Yup.string()
              .nullable()
              .required(`${t("integracion.update.codCuenta")}`),
            comentario: Yup.string()
              .nullable()
              .required(`${t("integracion.update.coment")}`),
            debe: Yup.string()
              .nullable()
              .required(`${t("integracion.update.debe")}`),
            haber: Yup.string()
              .nullable()
              .required(`${t("integracion.update.haber")}`),
            documentoConta: Yup.string()
              .nullable()
              .required(`${t("integracion.update.docContable")}`),
            cuenta: Yup.string()
              .nullable()
              .required(`${t("integracion.update.cuenta")}`),
            asiento: Yup.string()
              .nullable()
              .required(`${t("integracion.update.numAsiento")}`),
          })
          .nullable(),
      }),
    }),
    libroIva: Yup.object().when("screen", {
      is: MODES_INTEGRACIONES.LIBRO_IVA,
      then: Yup.object().shape({
        archive: Yup.object().nullable().required(),
        options: Yup.object()
          .shape({
            fecha: Yup.string()
              .nullable()
              .required(`${t("integracion.update.fechaAsiento")}`),
            baseIva: Yup.string()
              .nullable()
              .required(`${t("integracion.update.base")}`),
            cuotaIva: Yup.string()
              .nullable()
              .required(`${t("integracion.update.quote")}`),
            porcentajeIva: Yup.string()
              .nullable()
              .required(`${t("integracion.update.tax")}`),
            claveIva: Yup.string()
              .nullable()
              .required(`${t("integracion.update.field1")}`),
            noDeducible: Yup.string().nullable(),
            baseRetencion: Yup.string().nullable(),
            cuotaRetencion: Yup.string().nullable(),
            porcentajeRetencion: Yup.string().nullable(),
            claveRetencion: Yup.string().nullable(),
            numeroFactura: Yup.string().nullable(),
            serieFactura: Yup.string().nullable(),
            tipoFactura: Yup.string()
              .nullable()
              .required(`${t("integracion.update.tipoFactura")}`),
            numeroProveedorFactura: Yup.string()
              .nullable()
              .required(`${t("integracion.update.providerBillNumber")}`),
            nifContacto: Yup.string()
              .nullable()
              .required(`${t("integracion.update.contactNif")}`),
          })
          .nullable(),
        razonSocial: Yup.string().nullable(),
      }),
    }),
  })
